import { queryOptions, useQuery } from '@tanstack/react-query';

import type { TimeRange } from '@cast/shared-types';
import { NodeLabelFilters } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

const NODE_LABEL_NAMES_QUERY_KEY = 'node-label-names';

const getNodeLabelNamesQueryKey = ({
  key,
  filter,
}: {
  key: string;
  filter?: string;
}) => [NODE_LABEL_NAMES_QUERY_KEY, key, filter] as const;

type NodeLabelNamesQuery = {
  key: string;
  getRange: () => TimeRange;
  filter?: NodeLabelFilters;
  enabled?: boolean;
};

const getNodeLabelNamesQueryOptions = ({
  getRange,
  key,
  filter = {},
  enabled = true,
}: NodeLabelNamesQuery) => {
  const { from, to } = getRange();

  return queryOptions({
    queryKey: getNodeLabelNamesQueryKey({
      key,
      filter: JSON.stringify(filter),
    }),
    queryFn: async () => {
      const { data } = await apiClient.costReport.getNodeLabelNames({
        startTime: from,
        endTime: to,
        labelFilters: filter,
      });
      return data.labelNames ?? [];
    },
    enabled,
  });
};

export const useNodeLabelNamesQuery = (props: NodeLabelNamesQuery) => {
  const { isLoading, data, error, refetch } = useQuery(
    getNodeLabelNamesQueryOptions(props)
  );

  return {
    labelNames: data,
    isLoading,
    error,
    refetch,
  };
};
